module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-pickwick-bottom-01.1@2x.3c05b177.jpg";